import PropTypes from 'prop-types';
import React from 'react';

export default function TableCell(props) {
  const classes = [];

  const addClass = c => classes.push(`column-${c}`);

  if ('BOLD' === props.format) {
    addClass('bold');
  } else if ('ITALIC' === props.format) {
    addClass('italic');
  }

  if ('NUMBER' === props.datatype) {
    addClass('num');
  } else if ('DATE' === props.datatype) {
    addClass('date');
  }

  if (props.column_name) {
    addClass(props.column_name);
  }

  return props.header
       ? <th className={classes.join(' ')}>{ props.value }</th>
       : <td className={classes.join(' ')}>{ props.value }</td>
  ;
}

TableCell.propTypes = {
  header: PropTypes.bool,
  format: PropTypes.oneOf(['NORMAL', 'BOLD', 'ITALIC']),
  datatype: PropTypes.oneOf(['NUMBER', 'DATE', 'STRING']),
  value: PropTypes.string,
  column_name: PropTypes.string
};


// WEBPACK FOOTER //
// ./modules/Common/components/TableCell.js